import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
  name: 'urlSanitizer'
})
export class UrlSanitizerPipe implements PipeTransform {

  constructor(private sanitized: DomSanitizer) {}

  transform(url: string) {
    return this.sanitized.bypassSecurityTrustUrl(url);
  }

}
